export const addParamsToUrl = (url: string, params: URLSearchParams) => {
  const paramsString = params.toString();
  if (!paramsString) {
    return url;
  }
  return url.indexOf('?') !== -1
    ? url + '&' + paramsString
    : url + '?' + paramsString;
};
